var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel__list__item"},[_c('h3',{staticClass:"purple"},[_vm._v(_vm._s(_vm.item.name))]),_vm._v(" "),_c('div',[_c('b',[_c('i',[_vm._v(_vm._s(_vm.item.company))])])]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.item.description))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5833cca6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/panels/profile/ReferenceItem.vue
// module id = 859
// module chunks = 5